import DownloadView from '@/views/Download/DownloadView';

export default function DownloadPage() {
  return <DownloadView />;
}
